import { useContext } from "react";
import { SnackbarContext } from "../contexts/Snackbar/SnackbarContext";

const useSnackbar = () => {
  return useContext(SnackbarContext);
};

export default useSnackbar;
